import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ActivationInsertRequest } from "../shared/ActivationInsertRequest";
import { DataService_DigitalIDActivations } from "../shared/data.service";
import { DIdAddSchoolsComponent } from "./did-add-schools/did-add-schools.component";

@Component({
	selector: "app-digital-id-add-activation",
	templateUrl: "./digital-id-add-activation.component.html",
	styleUrls: ["./digital-id-add-activation.component.css"],
})
export class DigitalIdAddActivationComponent implements OnInit {
	constructor(
		private dialogService: DialogService,
		private ref: DynamicDialogRef,
		private DigitalIDActivationService: DataService_DigitalIDActivations,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	lstSchool: any = [];
	SelectedSchools: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
	];

	errorMessage: any = "";

	UpdateAll: number = 0;

	loading: boolean = false;

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////

	onRemove() {
		this.errorMessage = "";

		this.lstSchool = this.lstSchool.filter((school) => this.SelectedSchools.indexOf(school) == -1);
	}

	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(DIdAddSchoolsComponent, {
			header: "Add Schools",
			width: "fit-content",
			data: {
				SelectedSchools: this.lstSchool,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0) {
				this.lstSchool = response;

				for (var z = 0; z < this.lstSchool.length; z++) {
					var next = this.lstSchool[z];

					if (next.AvailableCount == undefined) {
						next.AvailableCount = 0;
					}
				}

				this.SelectedSchools = [];
			}
		});
	}

	onFinish() {
		this.errorMessage = "";

		if (this.lstSchool.length == 0) {
			this.errorMessage = "Select schools to add activations to";
			return;
		}

		this.loading = true;

		//
		// Create Parms
		//
		var lstSIDs: number[] = [];
		var lstCs: number[] = [];

		for (var z = 0; z < this.lstSchool.length; z++) {
			lstSIDs = [...lstSIDs, this.lstSchool[z].SchoolID];
			lstCs = [...lstCs, this.lstSchool[z].AvailableCount];
		}

		var parms: ActivationInsertRequest = {
			lstSchoolIDs: lstSIDs,
			lstCounts: lstCs,
		};

		//
		// Call WS
		//
		var result = this.DigitalIDActivationService.ActivationInsert(parms);
		result.subscribe(
			(response) => {
				this.loading = false;

				if (response) {
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Activations created successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create Activations",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	onUpdateAll() {
		for (var z = 0; z < this.lstSchool.length; z++) {
			var next = this.lstSchool[z];

			next.AvailableCount = this.UpdateAll;
		}
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
